import FacebookLogin from 'react-facebook-login';
import useGa from 'hooks/useGa';

const FacebookLoginButton = ({ callback, defaultIcon, text, autoLoad, className }) => {
    const gaTracking = useGa();

    const componentClicked = () => {
        gaTracking("login-fb");
    }

    const responseFacebook = (response) => {
        callback({...response, provider: "facebook"});
    }

    const responseError = (response) => {
        // console.log(response)
    }

    return (<>
        <FacebookLogin
            appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID ? process.env.REACT_APP_FACEBOOK_CLIENT_ID : ''}
            autoLoad={autoLoad}
            fields="name,email,picture"
            onClick={componentClicked}
            callback={responseFacebook}
            onFailure={responseError}
            cssClass={className && className}
            textButton={<>{defaultIcon && <i className="fab fa-facebook-square fa-lg mgr-2"></i>}{text}</>}
            disableMobileRedirect={true}
        />
    </>)
}

export default FacebookLoginButton;